import debounce from 'lodash/debounce';

export default function selectBox ($selectBoxes) {
	let update = ($currentBox, initiator = 'self') => {
		let boxType = $currentBox.data('select-box');
		let $boxHeading = $currentBox.find('[data-select-box-heading]');
		let $boxChecked = $currentBox.find('[data-select-box-checked]');
		let arrChecked = [];
		let textChecked = $boxHeading.data('checked-text');
		let textNonChecked = $boxHeading.data('non-checked-text');
		let $fields = $currentBox.find('.control__field');

		if (/^self$/i.test(initiator)) {
			if (boxType === 'single') {
				$fields.closest('.select-box__item').removeClass('is-disabled');
			}
		}

		$fields
			.filter(function () {
				return this.checked;
			})
			.each((i, field) => {
				let $field = $(field);

				arrChecked.push($field.closest('.control').find('.control__text').text());

				if (boxType === 'single') {
					$field.closest('.select-box__item').addClass('is-disabled');
				}
			});

		if (arrChecked.length) {
			$boxChecked.text(arrChecked.join(', '));

			if (boxType !== 'single') {
				$boxHeading.attr('title', `${textChecked}: \n${arrChecked.map(value => `✓ ${value}`).join('\n')}`);
			}
		} else {
			$boxChecked.text(textNonChecked);

			if (boxType !== 'single') {
				$boxHeading.attr('title', textNonChecked);
			}
		}
	};

	let reset = ($currentBox, initiator = 'self') => {
		let boxType = $currentBox.data('select-box');
		let $boxHeading = $currentBox.find('[data-select-box-heading]');
		let $boxChecked = $currentBox.find('[data-select-box-checked]');
		let textNonChecked = $boxHeading.data('non-checked-text');
		let $fields = $currentBox.find('.control__field');

		$fields.each((i, field) => {
			let $field = $(field);

			$field.prop('checked', false);
			$field.prop('disabled', false);

			if (boxType === 'single') {
				$field.closest('.select-box__item').removeClass('is-disabled');
			}
		});

		$boxChecked.text(textNonChecked);

		if (boxType !== 'single') {
			$boxHeading.attr('title', textNonChecked);
		}

		$(document).trigger('click.toggle.close');
	};

	$selectBoxes.each((i, box) => {
		let $box = $(box);

		update($box);

		$box.data('updateBox', update);
		$box.data('resetBox', reset);

		$box.on('click change', 'input', (e) => {
			let $thisBox = $(e.delegateTarget);

			update($thisBox);

			setTimeout(() => {
				$(e.target).closest('.select-box__item').addClass('is-active');
			}, 300);
		});
	});

	$selectBoxes.closest('form').on('reset', debounce(() => {
		$selectBoxes.each((i, box) => {
			update($(box));
		});
	}, 20));
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/selectBox.js